import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import Typography from '../../typography'
import SubscribeButton from '../action/subscribe'
import ContainerCustom from '../ContainerCustom'
import SkillsDevelopment from './SkillsDevelopment'
import DownloadButton from '../action/download'
import SpecializationFeatured from '../../images/specialization-future.png'

import { useBreakpoint } from '../../../../hooks/breakpoint'

import Image from '../../image'

const FeatureSpecialization = (props) => {
  const {
    title,
    aboutTitle,
    summary,
    about,
    headerImage,
    attachment,
    integrationSettings,
    index,
    meta,
    ...othersProps
  } = props
  const { mdOnly, mdAndDown } = useBreakpoint()

  return (
    <>
      <ContainerCustom className='flex flex-col mt-10'>
        <div className='flex flex-col sm:flex-row'>
          <div className='w-full sm:w-1/2'>
            <Typography
              className={index % 2 ? 'text-red-500' : 'text-green-500'}
              size={'eight'}
              weight='bold'>
              {title}
            </Typography>
            <Typography
              size='four'
              className='text-gray-500 pt-8'
              dangerouslySetInnerHTML={{ __html: summary }} />
            {
              !mdAndDown
                ? (
                  <div
                    className={'flex flex-col md:flex-row items-center justify-between py-10 -mx-2'} >
                    <SubscribeButton
                      className={
                        classNames([
                          index % 2 ? 'bg-red-500' : 'bg-green-500',
                          'text-white',
                          'mx-2',
                          'w-1/2'
                        ])
                      }
                      specialization={props}
                      integrationSettings={integrationSettings} />
                    {
                      get(attachment, 'meta.downloadUrl', null)
                        ? <DownloadButton
                          className={
                            classNames([
                              'bg-white',
                              'text-green-500',
                              'mx-2',
                              'w-1/2'
                            ])
                          }
                          specialization={props}
                          integrationSettings={integrationSettings} />
                        : null
                    }
                  </div>
                )
                : null
            }
          </div>
        </div>
        {
          mdAndDown
            ? (
              <div
                className={'flex flex-col md:flex-row items-center justify-between py-10 -mx-2'} >
                <SubscribeButton
                  className={
                    classNames([
                      index % 2 ? 'bg-red-500' : 'bg-green-500',
                      'text-white',
                      'mx-2',
                      'my-2',
                      'md:my-0',
                      'w-1/2'
                    ])
                  }
                  specialization={props}
                  integrationSettings={integrationSettings} />
                {
                  get(attachment, 'meta.downloadUrl', null)
                    ? <DownloadButton
                      className={
                        classNames([
                          'bg-white',
                          'text-green-500',
                          'mx-2',
                          'my-2',
                          'md:my-0',
                          'w-1/2'
                        ])
                      }
                      specialization={props}
                      integrationSettings={integrationSettings} />
                    : null
                }
              </div>
            )
            : null
        }
        <div className='flex items-start mt-20 flex-col sm:flex-row'>
          <Typography
            className={
              classNames([
                index % 2 ? 'text-red-500' : 'text-green-500',
                'mb-5',
                'sm:mb-0',
                'sm:text-4xl',
                'sm:w-1/2'
              ])
            }
            size={'seven'}
            weight='bold'>
            {aboutTitle}
          </Typography>
          <div className='flex flex-col sm:w-1/2 sm:pl-10'>
            {
              about && about.length
                ? about.map(({ value }, index) => {
                  const { icon: { meta, title } = {}, text } = value || {}
                  return (
                    <div className='flex items-start mb-4 sm:mb-7' key={`${title}-${index}`} >
                      <Image className='w-6 h-6 m-1 mr-4' alt={`icon-${title}`} src={meta.downloadUrl} />
                      <Typography size='five' className='text-gray-500'>{text}</Typography>
                    </div>
                  )
                })
                : null
            }
          </div>
        </div>
        {
          headerImage
            ? <Image
              alt={headerImage.title || 'specialization-feautured'}
              className='md:absolute md:-right-40'
              style={{
                borderRadius: '40px 0 0 40px',
                ...mdOnly
                  ? {
                    maxHeight: 260,
                    maxWidth: 500
                  }
                  : {
                    maxHeight: 340,
                    maxWidth: 605
                  }
              }}
              src={headerImage.meta ? headerImage.meta.downloadUrl : ''} />
            : <Image
              alt='specialization-feautured'
              style={{
                borderRadius: '40px 0 0 40px',
                ...mdOnly
                  ? {
                    maxHeight: 260,
                    maxWidth: 500
                  }
                  : {
                    maxHeight: 340,
                    maxWidth: 605
                  }
              }}
              className='md:absolute md:-right-40'
              src={SpecializationFeatured} />
        }
      </ContainerCustom>
      <SkillsDevelopment index={index} slug={meta.slug} {...{ ...othersProps, attachment }} />
    </>
  )
}

FeatureSpecialization.propTypes = {
  title: PropTypes.string,
  aboutTitle: PropTypes.string,
  summary: PropTypes.string,
  about: PropTypes.array,
  attachment: PropTypes.object,
  headerImage: PropTypes.object,
  integrationSettings: PropTypes.object,
  index: PropTypes.number,
  meta: PropTypes.array
}

export default FeatureSpecialization
